import React, { useEffect, useState } from 'react';
//import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from '../../store/actions/actionIndex';
import { decryptData } from '../../helpers/utility';

function Logout(props) {
  const { onLogout, agentId } = props;

useEffect(() => {
  const Logout = async () => {
      onLogout(agentId);
      window.web_logout();
      const decodedToken = await decryptData();
      if (decodedToken) {
        window.location.href = decodedToken.logoutURL;
          localStorage.clear("accessToken");
      } else {
          window.location.reload();
      }
  };

  Logout();
}, [agentId, onLogout]);

  return <></> ;
};

const mapStateToProps = (state) => {
  return {
    loading: state.agentData.loading,
    error: state.agentData.error,
    agentId: state.agentData.agentId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (agentId) => dispatch(actions.agentLogout(agentId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
